import { c as _c } from "react/compiler-runtime";
import { FormInput, Hint, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useResetFunnelStepPageTemplate } from 'modules/funnels/funnel/hooks/use-reset-funnel-step-page-template';
import { useWebinarRegistrationSettings } from 'modules/funnels/funnel/hooks/use-webinar-registration-settings';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useEffect, useState } from 'react';
import FormUrlPathInput from 'shared/components/form-url-path-input';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
import { getStateStatusIcon } from 'shared/utils/get-status-icon';
import { useFunnelStepsList } from '../../hooks/use-funnel-steps-list';
import { useBaseConfigurationTabFieldState, useUpdateBaseConfigurationTab } from '../../hooks/use-update-base-configuration-tab';
import { WebinarRegistrationEditErrorsInterface, WebinarRegistrationEditInterface, WebinarRegistrationFieldErrorResponseContentInterface, WebinarRegistrationInterface } from '../../types/webinar-registration-interface';
import { getFunnelStepPreviewData } from '../../utils/get-funnel-step-split-test-preview-data';
import { getFunnelStepPageUrl } from '../../utils/page-utils';
import SplitTestPreviewStepModal from './split-test-preview-step-modal';
import StepConfigurationTabLayout from './step-configuration-tab-layout';
const defaultValues: WebinarRegistrationEditInterface = {
  name: '',
  page: {
    path: ''
  },
  webinar: {
    duration: 0
  }
};
const defaultErrors: WebinarRegistrationEditErrorsInterface = {
  name: '',
  page: {
    path: ''
  },
  webinar: {
    duration: ''
  }
};
interface WebinarRegistrationConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function WebinarRegistrationConfigurationTab(t0) {
  const $ = _c(112);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    webinarRegistrationSettings,
    mutateWebinarRegistrationSettings
  } = useWebinarRegistrationSettings(funnelStep.id);
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStep.id) {
    t1 = {
      funnelId,
      funnelStepId: funnelStep.id
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    resetFunction
  } = useResetFunnelStepPageTemplate(t1);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultErrors);
  const [splitTestPreviewOpen, setSplitTestPreviewOpen] = useState(false);
  const [savedState, setSavedState] = useState(defaultValues);
  const t2 = `${FUNNELS_API}/steps/${funnelStep.id}/webinar-registration`;
  let t3;
  if ($[3] !== funnelId || $[4] !== funnelStep.id || $[5] !== t2) {
    t3 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t2
    };
    $[3] = funnelId;
    $[4] = funnelStep.id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    updateFetcher,
    isFetching
  } = useUpdateBaseConfigurationTab(t3);
  let t4;
  if ($[7] !== savedState || $[8] !== tempState) {
    t4 = {
      savedState,
      currentState: tempState
    };
    $[7] = savedState;
    $[8] = tempState;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    isNameChanged,
    isPagePathChanged,
    isWebinarDurationChanged,
    successState,
    setSuccessState
  } = useBaseConfigurationTabFieldState(t4);
  let t5;
  if ($[10] !== funnelStep.id || $[11] !== isNameChanged || $[12] !== isPagePathChanged || $[13] !== isWebinarDurationChanged || $[14] !== mutateFunnelStepsList || $[15] !== mutateWebinarRegistrationSettings || $[16] !== setSuccessState || $[17] !== tempState || $[18] !== updateFetcher) {
    t5 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        await updateFetcher(tempState, async () => {
          setSuccessState(prev_0 => ({
            ...prev_0,
            name: isNameChanged,
            path: isPagePathChanged,
            webinarDuration: isWebinarDurationChanged
          }));
          setSavedState({
            ...tempState
          });
          await mutateWebinarRegistrationSettings(data => {
            if (data) {
              return {
                ...data,
                name: tempState.name,
                page: {
                  ...data.page,
                  path: tempState.page.path
                },
                webinar: {
                  ...data.webinar,
                  duration: tempState.webinar.duration
                }
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: tempState.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t6) {
        const e = t6;
        if (e instanceof BadRequest) {
          if (e.errors.common.length !== 0) {
            toast.error(e.errors.common.join(""));
          }
          if (e.errors.fields) {
            const errors_0 = e.errors.fields as unknown as WebinarRegistrationFieldErrorResponseContentInterface;
            setErrors(prev => ({
              ...prev,
              name: errors_0.name?.join(""),
              page: {
                path: errors_0.page?.path?.join("")
              },
              webinar: {
                duration: errors_0.webinar?.duration?.join("")
              }
            }));
          }
        }
      }
    };
    $[10] = funnelStep.id;
    $[11] = isNameChanged;
    $[12] = isPagePathChanged;
    $[13] = isWebinarDurationChanged;
    $[14] = mutateFunnelStepsList;
    $[15] = mutateWebinarRegistrationSettings;
    $[16] = setSuccessState;
    $[17] = tempState;
    $[18] = updateFetcher;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const handleSave = t5;
  let t6;
  let t7;
  if ($[20] !== webinarRegistrationSettings) {
    t6 = () => {
      if (webinarRegistrationSettings) {
        setTempState(prev_1 => ({
          ...prev_1,
          name: webinarRegistrationSettings.name,
          page: {
            path: webinarRegistrationSettings.page.path
          },
          webinar: {
            duration: webinarRegistrationSettings.webinar.duration
          }
        }));
        setSavedState(prev_2 => ({
          ...prev_2,
          name: webinarRegistrationSettings.name,
          page: {
            path: webinarRegistrationSettings.page.path
          },
          webinar: {
            duration: webinarRegistrationSettings.webinar.duration
          }
        }));
      }
    };
    t7 = [webinarRegistrationSettings];
    $[20] = webinarRegistrationSettings;
    $[21] = t6;
    $[22] = t7;
  } else {
    t6 = $[21];
    t7 = $[22];
  }
  useEffect(t6, t7);
  if (!webinarRegistrationSettings || !funnel || !funnelStep.page) {
    let t8;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    return t8;
  }
  let t8;
  if ($[24] !== funnel || $[25] !== funnelStep || $[26] !== t) {
    t8 = getFunnelStepPreviewData({
      funnelStep,
      setOpen: setSplitTestPreviewOpen,
      funnel,
      t,
      previewLinkWithQuery: true
    });
    $[24] = funnel;
    $[25] = funnelStep;
    $[26] = t;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const {
    customViewButton,
    funnelStepAPreviewLink,
    funnelStepBPreviewLink,
    isSplitTestPreview
  } = t8;
  let t9;
  if ($[28] !== funnel.domain.domainName || $[29] !== webinarRegistrationSettings.page.path) {
    t9 = getFunnelStepPageUrl(funnel.domain.domainName, webinarRegistrationSettings.page.path);
    $[28] = funnel.domain.domainName;
    $[29] = webinarRegistrationSettings.page.path;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== funnelStep.page.id) {
    t10 = getPageEditorUrl(funnelStep.page.id);
    $[31] = funnelStep.page.id;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t) {
    t11 = t("global.name");
    $[33] = t;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  const t12 = tempState.name;
  let t13;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_0 => setTempState(prev_3 => ({
      ...prev_3,
      name: e_0.target.value
    }));
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== handleSave || $[37] !== isNameChanged) {
    t14 = () => isNameChanged && handleSave();
    $[36] = handleSave;
    $[37] = isNameChanged;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  const t15 = successState.name;
  const t16 = isFetching && isNameChanged;
  let t17;
  if ($[39] !== successState.name || $[40] !== t16) {
    t17 = getStateStatusIcon(t16, successState.name);
    $[39] = successState.name;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== errors.name || $[43] !== successState.name || $[44] !== t11 || $[45] !== t14 || $[46] !== t17 || $[47] !== tempState.name) {
    t18 = <FormInput required={true} label={t11} labelClassName="lg:text-[15px] font-medium text-sm text-text-primary" value={t12} onChange={t13} onBlur={t14} maxLength={256} success={t15} statusIcon={t17} error={errors.name} />;
    $[42] = errors.name;
    $[43] = successState.name;
    $[44] = t11;
    $[45] = t14;
    $[46] = t17;
    $[47] = tempState.name;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t) {
    t19 = t("dashboard.funnel.configuration.webinar.duration_popover");
    $[49] = t;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t) {
    t20 = t("dashboard.funnel.configuration.webinar.duration");
    $[51] = t;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t19 || $[54] !== t20) {
    t21 = <Hint label={t19} className="text-text-primary text-sm font-medium lg:text-[15px]">{t20}</Hint>;
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  const t22 = tempState.webinar?.duration;
  let t23;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = e_1 => setTempState(prev_4 => ({
      ...prev_4,
      webinar: {
        duration: parseInt(e_1.target.value) || 0
      }
    }));
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== handleSave || $[58] !== isWebinarDurationChanged) {
    t24 = () => isWebinarDurationChanged && handleSave();
    $[57] = handleSave;
    $[58] = isWebinarDurationChanged;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  const t25 = successState.webinarDuration;
  const t26 = isFetching && isWebinarDurationChanged;
  let t27;
  if ($[60] !== successState.webinarDuration || $[61] !== t26) {
    t27 = getStateStatusIcon(t26, successState.webinarDuration);
    $[60] = successState.webinarDuration;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== errors.webinar.duration || $[64] !== successState.webinarDuration || $[65] !== t21 || $[66] !== t22 || $[67] !== t24 || $[68] !== t27) {
    t28 = <FormInput label={t21} type="number" value={t22} onChange={t23} onBlur={t24} maxLength={256} success={t25} statusIcon={t27} error={errors.webinar.duration} />;
    $[63] = errors.webinar.duration;
    $[64] = successState.webinarDuration;
    $[65] = t21;
    $[66] = t22;
    $[67] = t24;
    $[68] = t27;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  const t29 = `border border-text-secondary/30 hover:border-brand-primary group !bg-background-secondary [&>*]:group-hover:!fill-brand-primary ${successState.path && "border-green"}`;
  const t30 = tempState.page?.path;
  const t31 = funnel?.domain.domainName;
  let t32;
  if ($[70] !== t) {
    t32 = t("dashboard.funnel.configuration.webinar.url_path_popover-2");
    $[70] = t;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t) {
    t33 = t("global.url_path");
    $[72] = t;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t32 || $[75] !== t33) {
    t34 = <Hint label={t32} className="text-text-primary text-sm font-medium lg:text-[15px]">{t33}</Hint>;
    $[74] = t32;
    $[75] = t33;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = e_2 => setTempState(prev_5 => ({
      ...prev_5,
      page: {
        path: e_2.target.value
      }
    }));
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== handleSave || $[79] !== isPagePathChanged) {
    t36 = () => isPagePathChanged && handleSave();
    $[78] = handleSave;
    $[79] = isPagePathChanged;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  const t37 = funnelStep.inRunningSplitTest;
  const t38 = successState.path;
  const t39 = isFetching && isPagePathChanged;
  let t40;
  if ($[81] !== successState.path || $[82] !== t39) {
    t40 = getStateStatusIcon(t39, successState.path);
    $[81] = successState.path;
    $[82] = t39;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  let t41;
  if ($[84] !== errors.page.path || $[85] !== funnelStep.inRunningSplitTest || $[86] !== successState.path || $[87] !== t29 || $[88] !== t30 || $[89] !== t31 || $[90] !== t34 || $[91] !== t36 || $[92] !== t40) {
    t41 = <FormUrlPathInput required={true} copyButtonClassName={t29} copyIconClassName="fill-text-secondary group-hover:fill-brand-primary main-transition-colors" value={t30} domainName={t31} label={t34} onChange={t35} onBlur={t36} disabled={t37} success={t38} statusIcon={t40} error={errors.page.path} />;
    $[84] = errors.page.path;
    $[85] = funnelStep.inRunningSplitTest;
    $[86] = successState.path;
    $[87] = t29;
    $[88] = t30;
    $[89] = t31;
    $[90] = t34;
    $[91] = t36;
    $[92] = t40;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t18 || $[95] !== t28 || $[96] !== t41) {
    t42 = <div className="flex flex-col gap-5">{t18}{t28}{t41}</div>;
    $[94] = t18;
    $[95] = t28;
    $[96] = t41;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  let t43;
  if ($[98] !== customViewButton || $[99] !== resetFunction || $[100] !== t10 || $[101] !== t42 || $[102] !== t9) {
    t43 = <StepConfigurationTabLayout viewLinkUrl={t9} editLinkUrl={t10} onChangeTemplate={resetFunction} customViewButton={customViewButton}>{t42}</StepConfigurationTabLayout>;
    $[98] = customViewButton;
    $[99] = resetFunction;
    $[100] = t10;
    $[101] = t42;
    $[102] = t9;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  let t44;
  if ($[104] !== funnelStepAPreviewLink || $[105] !== funnelStepBPreviewLink || $[106] !== isSplitTestPreview || $[107] !== splitTestPreviewOpen) {
    t44 = isSplitTestPreview && <SplitTestPreviewStepModal open={splitTestPreviewOpen} setOpen={setSplitTestPreviewOpen} stepAPreviewLink={funnelStepAPreviewLink} stepBPreviewLink={funnelStepBPreviewLink} />;
    $[104] = funnelStepAPreviewLink;
    $[105] = funnelStepBPreviewLink;
    $[106] = isSplitTestPreview;
    $[107] = splitTestPreviewOpen;
    $[108] = t44;
  } else {
    t44 = $[108];
  }
  let t45;
  if ($[109] !== t43 || $[110] !== t44) {
    t45 = <>{t43}{t44}</>;
    $[109] = t43;
    $[110] = t44;
    $[111] = t45;
  } else {
    t45 = $[111];
  }
  return t45;
}
export default WebinarRegistrationConfigurationTab;